import { useSidebar } from '../../contexts/SidebarContext';
import React from 'react';
import AgencyDashboard from '../items/Dashboard/AgencyDashboard';
import { useDashboardView } from '../../hooks/useDashboardView';
import CompanyDashboard from '../items/Dashboard/CompanyDashboard';
import AgentDashboard from '../items/Dashboard/AgentDashboard';
import AgencyReports from 'components/items/Dashboard/AgencyReports';
import AgentReports from 'components/items/Dashboard/AgentReports';

interface DashboardProps {
    userDetails: any;
    onLogout: () => void;
}

const Dashboard: React.FC<DashboardProps> = ({
    userDetails,
    onLogout
}) => {

    const { currentView } = useDashboardView({ userDetails, onLogout });
    
    if (currentView === "agency_dashboard") {
        return <AgencyDashboard userDetails={userDetails} />;
    } else if (currentView === "company_dashboard") {
        return <CompanyDashboard userDetails={userDetails} />;
    } else if (currentView === "agent_dashboard") {
        return <AgentDashboard userDetails={userDetails}/>;
    } else if (currentView === "agent_reports") {
        return <AgentReports userDetails={userDetails} />;
    } else if (currentView === "agency_reports") {
        return <AgencyReports userDetails={userDetails} />;
    }

    return null;
};

export default Dashboard;